import React from 'react';
import { Link, useHistory } from 'react-router-dom';

import Alert from '../../../../components/Alert';
import Button from '../../../../components/Button';
import StepProgress from '../../../../components/StepProgress';
import steps from '../../../../utils/steps.json';

import { ContainerButton, PageContainer } from '../../../../styles/styles';

const contributario = {
    title: 'Beneficiário elegível para plano continuidade.',
    message: [
        'Este contrato permite que beneficiários optem por continuar utilizando o mesmo plano após o desligamento. Para iniciar o processo para este beneficiário, acesse ',
        <Link to="/movimentacao_cadastral/selecionar_aposentados_demitidos">
            <u>Aposentados e demitidos.</u>
        </Link>,
    ],
};

function AguardarAnalise({ location: { exigeTermoContributario } }) {
    const successTitle = 'Você desligou beneficiário.';
    const successMessage = [
        'Nos próximos 3 dias úteis vamos analisar o formulário com as informações para efetivar o desligamento de beneficiário.',
        ' Acompanhe o status da sua solicitação pelo ',
        <Link to="/movimentacao_cadastral/movimentacoes_pendentes">
            <u>Movimentações pendentes.</u>
        </Link>,
    ];

    const history = useHistory();

    return (
        <PageContainer>
            <StepProgress steps={steps.desligarBeneficiario} activeStep={3} />

            <Alert type={3} title={successTitle} message={successMessage} />

            {exigeTermoContributario && <Alert type={4} title={contributario.title} message={contributario.message} />}

            <ContainerButton>
                <Button id="backStep" type="secondary" onClick={() => history.push('/')}>
                    Acessar home
                </Button>

                <Button
                    id="continueStep"
                    type="primary"
                    onClick={() => history.push('/movimentacao_cadastral/selecionar_desligar_beneficiario')}
                >
                    Novo desligamento
                </Button>
            </ContainerButton>
        </PageContainer>
    );
}

export default AguardarAnalise;
